module.exports = __webpack_public_path__ + "static/img/login_left.35636b8e.png";